var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    viewBox: "0 0 16 11",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 10,
    rx: 1,
    width: 14,
    x: 1.333333,
    y: 0.666667
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07319c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00247e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d51931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2adb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b9497"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2b2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#febb2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a84b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#913f0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfb063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bea157"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d42ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b24fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3dc3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfc82a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f8012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6a0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcc72e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.00454531.33727487c-.00251031-.18627177.13928976-.33727487.32571401-.33727487h1.33948136c.18239719 0 .33233213.15380859.33480463.33727487l.01569709 1.1634922c.00121755.09162382-.06413112.20964146-.13838873.25859674l-.73001594.48127238c-.07765524.05119522-.20548319.04895528-.27809143 0l-.7138012-.48127238c-.0759304-.05119522-.13844928-.16431172-.13971992-.25859674z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.00454531.33727487c-.00251031-.18627177.13928976-.33727487.32571401-.33727487h1.33948136c.18239719 0 .33233213.15380859.33480463.33727487l.01569709 1.1634922c.00121755.09162382-.06413112.20964146-.13838873.25859674l-.73001594.48127238c-.07765524.05119522-.20548319.04895528-.27809143 0l-.7138012-.48127238c-.0759304-.05119522-.13844928-.16431172-.13971992-.25859674z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.00454531.33727487c-.00251031-.18627177.13928976-.33727487.32571401-.33727487h1.33948136c.18239719 0 .33233213.15380859.33480463.33727487l.01569709 1.1634922c.00121755.09162382-.06413112.20964146-.13838873.25859674l-.73001594.48127238c-.07765524.05119522-.20548319.04895528-.27809143 0l-.7138012-.48127238c-.0759304-.05119522-.13844928-.16431172-.13971992-.25859674z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.00454531.33727487c-.00251031-.18627177.13928976-.33727487.32571401-.33727487h1.33948136c.18239719 0 .33233213.15380859.33480463.33727487l.01569709 1.1634922c.00121755.09162382-.06413112.20964146-.13838873.25859674l-.73001594.48127238c-.07765524.05119522-.20548319.04895528-.27809143 0l-.7138012-.48127238c-.0759304-.05119522-.13844928-.16431172-.13971992-.25859674z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.333333.666667h14v10h-14z",
    fill: "url(#c)",
    fillRule: "nonzero",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.33333333 2.81997831-2.9010858-2.48664498h1.34124082l2.33333334 1.66666667h.46424624l3.09559874-1.93474921v.76808254c0 .20167282-.1112763.41768904-.27856019.53717753l-2.05477315 1.46769511v.34181572l2.09148033 1.79269742c.30808141.26406979.13587232.69394756-.25814699.69394756-.16347591 0-.36314994-.06404399-.49938565-.16135522l-2.10743604-1.50531145h-.46424624l-3.09559874 1.93474921v-1.10628851l2.33333333-1.66666667z",
    fill: "url(#a)",
    fillRule: "nonzero",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.66666667 2.66666667-2.33333334-2h.33333334l2.33333333 1.66666666h.66666667l2.66666666-1.66666666v.16666666c0 .09204746-.05767822.2078654-.13897292.26593304l-2.19436041 1.5674003v.66666666l2.2078832 1.89247132c.06928419.05938645.04813893.10752868-.04121653.10752868-.09204746 0-.22434489-.04119873-.30563959-.09926637l-2.19436041-1.56740029h-.66666667l-2.66666667 1.66666666v-.33333333l2.33333334-1.66666667z",
    fill: "url(#d)",
    fillRule: "nonzero",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.33333333 2.33333333v1.33333334h2.33333334v1.66974068c0 .18239718.14269002.33025932.3364563.33025932h.66042073c.18581969 0 .3364563-.14383507.3364563-.33025932v-1.66974068h2.33968099c.1805892 0 .32698568-.14269002.32698568-.3364563v-.66042074c0-.18581968-.14337158-.3364563-.32698568-.3364563h-2.33968099v-1.66666666h-1.33333333v1.66666666z",
    fill: "url(#a)",
    fillRule: "nonzero",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.33333333 2.66666667h2.66666667v-.33333334-1.66666666h.66666667v1.66666666.33333334h2.66666666v.66666666h-2.66666666v.33333334 1.66666666h-.66666667v-1.66666666-.33333334h-2.66666667z",
    fill: "url(#d)",
    fillRule: "nonzero",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(12.666667 6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    fill: "url(#e)",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.666667,
    cy: 1.333333,
    fill: "url(#a)",
    mask: "url(#q)",
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(10 6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    fill: "url(#f)",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.333333,
    cy: 1.333333,
    fill: "url(#g)",
    mask: "url(#r)",
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.3333333 9c.5522848.33333333 1 .18409493 1 0s-.4477152-.33333333-1-.33333333c-.5522847 0-1 .1492384-1 .33333333s.4477153.33333333 1 0z",
    fill: "url(#h)",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.666667,
    cy: 4.333333,
    fill: "url(#a)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.333333,
    cy: 3.666667,
    fill: "url(#i)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.333333,
    cy: 3.166667,
    fill: "url(#j)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.333333,
    cy: 8.333333,
    fill: "url(#a)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4.333333,
    fill: "url(#a)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.333333,
    cy: 5,
    fill: "url(#k)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.333333,
    cy: 5,
    fill: "url(#k)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 6,
    fill: "url(#l)",
    mask: "url(#p)",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 5.66666667-.3333333.33333333h1.3333333l-.3333333-.33333333.3333333-1s-.2984769-.66666667-.6666667-.66666667-.6666666.66666667-.6666666.66666667z",
    fill: "url(#m)",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.3333333 5s.3333334-.07461921.3333334-.25333341c0-.00538072-.3333334-.07999992-.3333334-.07999992s-.3333333.0746192-.3333333.07999992c0 .1787142.3333333.25333341.3333333.25333341z",
    fill: "#5d0543",
    mask: "url(#p)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(11.333333 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.00454531.33727487c-.00251031-.18627177.13928976-.33727487.32571401-.33727487h1.33948136c.18239719 0 .33233213.15380859.33480463.33727487l.01569709 1.1634922c.00121755.09162382-.06413112.20964146-.13838873.25859674l-.73001594.48127238c-.07765524.05119522-.20548319.04895528-.27809143 0l-.7138012-.48127238c-.0759304-.05119522-.13844928-.16431172-.13971992-.25859674z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.666667,
    cy: 1.666667,
    fill: "#225da4",
    mask: "url(#s)",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.333333,
    cy: 1,
    fill: "#225da4",
    mask: "url(#t)",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2l-1 2z",
    fill: "url(#n)",
    mask: "url(#u)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    fill: "url(#o)",
    mask: "url(#v)",
    r: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs);
export default __webpack_public_path__ + "static/media/GS.a57ddfd3c886a107ea70a694f8614577.svg";
export { ForwardRef as ReactComponent };